import { useQuery } from '@tanstack/react-query';

import { fetchRequest, usePrepareRequest } from '../helpers';
import { AUTHENTICATION } from '../constants';
import { type UserInfoResponse } from './useGetUserInfoQuery.types';

export function useGetUserInfoQuery() {
  const { headers, endpoint } = usePrepareRequest({ serviceApi: AUTHENTICATION });

  const queryFn = () => {
    return fetchRequest<UserInfoResponse>({ headers, url: `${endpoint}/userinfo` });
  };

  return useQuery({ queryKey: ['userInfo'], queryFn, staleTime: Infinity });
}
